module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/store_images/2_99a9f115198867a5af29bd99f629d712.png";